module.exports = __webpack_public_path__ + "img/avatar4.7b92e407.png";